import classNames from "classnames";
import React, { ButtonHTMLAttributes, FC, useRef } from "react";

import { Icon, IconName } from "../icon";

import "./icon-button.css";

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	isActive?: boolean;
	iconName?: IconName;
	title?: string;
	/** Add shadow as round button */
	elevated?: boolean;
}

export const IconButton: FC<IconButtonProps> = ({
	iconName,
	type = "button",
	title,
	isActive,
	className,
	elevated = false,
	children,
	...props
}) => {
	const cssClass = classNames([
		"icon-button",
		{
			"icon-button--active": isActive,
			"icon-button--no-title": !title,
			"icon-button--elevated": elevated,
		},
		className,
	]);

	const ref = useRef<HTMLButtonElement>(null);

	return (
		<button
			className={cssClass}
			// https://github.com/jsx-eslint/eslint-plugin-react/issues/1555

			type={type}
			ref={ref}
			{...props}
		>
			<div className="icon-button__icon">
				<Icon iconName={iconName}>{children}</Icon>
			</div>

			{title && <div className="icon-button__title">{title}</div>}
		</button>
	);
};
IconButton.displayName = "IconButton";
